import { MySupportsCtrl } from './my-supports.controller';

angular.module('nv.my-supports', []).controller('MySupportsCtrl', MySupportsCtrl);
